import { SPGet, meshLog } from "./spUtils";
import { transIntToHex4Str, getOctets2Msg } from "./dataUtils";

//传感器设备
export const IsSensorDevice = (pid) => {
    let mPids = ["1001","1006","1007","1008","100A","100B","100C","100D","100E","100F","1010","1011","1012","1013","1014","1015","101A","101B","101C","1043","1044","1045","1046","1047","1048","1049","104D","104E","1051","1052","1053","1056","1057","1058","1059","105A","105B","105D","105E","105F","1060","1061","1062","1065","1066"];
    return judgeContailPid(mPids, pid);
}

//带色温的传感器
export const IsCCTSensorDevice = (pid) => {
    let mPids = ["1006"];
    return judgeContailPid(mPids, pid);
}

//双感传感器
export const IsUSPIRSensor = (pid) => {
    let mPids = ["100F", "1010"];
    return judgeContailPid(mPids, pid);
}

//调光调色设备
export const IsCCTControl = (pid) => {
    let mPids = ["1006","1007","1008","1059","105A","105B","105D","105E","105F"];
    return judgeContailPid(mPids, pid);
}

//微波传感器
export const IsMWSensor = (pid) => {
    let mPids = ["100B","1012","1015","101A","1043","1047","1048","104D","1058"];
    return judgeContailPid(mPids, pid);
}

//计量设备
export const IsME = (pid) => {
    let mPids = ["1002"];
    return judgeContailPid(mPids, pid);
}

//网关设备
export const IsGateway = (pid) => {
    let mPids = ["1004"];
    return judgeContailPid(mPids, pid);
}

//遥控器
export const IsRemote = (pid) => {
    let mPids = ["1005","104C","104A","1064"];
    return judgeContailPid(mPids, pid);
}

//Dongle
export const IsDongle = (pid) => {
    let mPids = ["1009"];
    return judgeContailPid(mPids, pid);
}

//自发电
export const IsZifadian = (pid) => {
    let mPids = ["101D", "101E", "104F", "3333"];
    return judgeContailPid(mPids, pid);
}

//激光遥控器
export const IsBluetoothRemote = (pid) => {
    let mPids = ["104A"];
    return judgeContailPid(mPids, pid);
}

//角度控制器
export const IsLightAngleController = (pid) => {
    let mPids = ["104B"];
    return judgeContailPid(mPids, pid);
}

//低功耗
export const IsMonster = (pid) => {
    let mPids = ["1054"];
    return judgeContailPid(mPids, pid);
}

//计量dongle
export const IsMeDongle = (pid) => {
    let mPids = ["1055","1111"];
    return judgeContailPid(mPids, pid);
}

//应急电源
export const IsEmergencyDevice = (pid) => {
    let mPids = ["1003","1016","1017","1018","1019","101F","1020","1021","1022","1023","1024","1025","1026","1027","1028","1029","102A","102B","102C","102D","102E","102F","1030","1031","1032","1033","1034","1035","1036","1037","1038","1039","103A","103B","103C","103D","103E","103F","1040","1041","1042","105C","1063"];
    return judgeContailPid(mPids, pid);
}

//应急控制器
export const IsEmergencyController = (pid) => {
    let mPids = ["1050"];
    return judgeContailPid(mPids, pid);
}

//应急灯
export const IsEmergencyLight = (pid) => {
    let mPids = ["1063"];
    return judgeContailPid(mPids, pid);
}

//小眼睛设备
export const SupportEyes = (pid) => {
    let mPids = ["1001","1002","1006","1007","1008","100A","100B","100C","100D","100E","100F","1010","1011","1012","1013","1014","1015","101A","101B","101C","1043","1044","1045","1046","1047","1048","1049","104B","104D","104E","1050","1051","1052","1053","105D","105E","105F","1060","1061","1062","1065","1066"];
    return judgeContailPid(mPids, pid);
}

//优先连接设备
export const IsPreConnect = (pid) => {
    let mPids = ["1004"];
    return judgeContailPid(mPids, pid);
}

//支持自发电设备
export const SupportZifaDian = (pid) => {
    let mPids = ["1001","1006","1007","1008","100A","100B","100C","100D","100E","1011","1012","1013","1014","1015","101A","101B","101C","1043","1044","1045","1046","1047","1048","1049","104D","104E","1051","1052","105D","105E","105F","1060","1061","1062","1065","1066"];
    return judgeContailPid(mPids, pid);
}


//判断是不是灯 需要转换pid
export const IsDevicePir = (pid) => {
    let mPids = ["1001", "1006", "1007", "1008", "100A", "100B", "100C", "100D", "100E", "100F", "1010", "1011", "1012", "1013", "1014", "1015", "101A", "101B", "101C", "1043", "1044", "1045", "1046", "1047", "1048", "1049", "104D", "104E", "1050", "1051", "1052", "1053"];
    return judgeContailPid(mPids, pid);
}

//网关、计量设备、计量dongle
export const IsMeasureyOrDongle = (pid) => {
    let mPids = ["1002", "1004", "1055"];
    return judgeContailPid(mPids, pid);
}

function judgeContailPid(mPids, pid) {
    for (let i = 0; i < mPids.length; i++) {
        if (mPids[i] == transIntToHex4Str(pid)) {
            return true;
        }
    }
    return false;
}


export const getDeviceNameByPid = (pid) => {
    let deviceType;
    let deviceImgName;

    if (IsSensorDevice(pid) || IsMonster(pid)) {
        deviceType = "PIR Sensor";
        deviceImgName = "icon_zones_sensor";
        if (IsMWSensor(pid)) {
            deviceType = "MW Sensor";
            deviceImgName = "icon_zones_sensor";
        } else if (IsUSPIRSensor(pid)) {
            deviceType = "US & PIR Sensor";
            deviceImgName = "icon_zones_sensor";
        } else if (IsCCTSensorDevice(pid)) {
            deviceType = "CCT PIR Sensor";
            deviceImgName = "icon_zones_sensor";
        } else if (IsLightAngleController(pid)) {
            deviceType = "Light Angle Controller";
            deviceImgName = "icon_zones_sensor";
        }
    } else if (IsME(pid)) {
        deviceType = "Group Controller";
        deviceImgName = "icon_dev_ME";
    } else if (IsEmergencyDevice(pid)) {
        deviceType = "Emergency Driver";
        deviceImgName = "icon_dev_EPS";
    } else if (IsGateway(pid)) {
        deviceType = "Gateway";
        deviceImgName = "icon_dev_gateway";
    } else if (IsRemote(pid)) {
        deviceType = "Wall Switch";
        deviceImgName = "icon_dev_remote";
    } else if (IsDongle(pid)) {
        deviceType = "Dongle";
        deviceImgName = "icon_dev_dongle";
    } else if (IsZifadian(pid)) {
        deviceType = "Wall Switch";
        deviceImgName = "icon_dev_zifadian";
    } else if (IsBluetoothRemote(pid)) {
        deviceType = "Bluetooth Remote";
        deviceImgName = "icon_dev_bluetoothRemote";
    } else if (IsEmergencyController(pid)) {
        deviceType = "Emergency Controller";
        deviceImgName = "icon_emergency_controller";
    } else {
        deviceType = "PIR";
        deviceImgName = "icon_zones_sensor";
    }
    return deviceType;
}
